import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireAvia_gam } from "/home/runner/work/avia-js/avia-js/libs/plugins/gam/dist/avia.gam.cjs";
var avia_gamExports = requireAvia_gam();
export { avia_gamExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(avia_gamExports);